import {
  CUSTOM_ROSTER_EXTRA_ROLES,
  CUSTOM_ROSTER_FIXED_ROLES,
  CUSTOM_ROSTER_WOLF_CATALOG,
  CUSTOM_ROSTER_WOLF_CHOICES,
  CUSTOM_ROSTER_WOLF_PAIR,
  type CustomRosterPlayerCount,
  type PlayerRoleType,
} from '@repo/sdk'

export function customRosterSelections(roles: ReadonlySet<string>): {
  extraRole: string | undefined
  wolfChoice: string | undefined
} {
  const extraRoles = [...roles].filter(role => CUSTOM_ROSTER_EXTRA_ROLES.includes(role as PlayerRoleType))
  const wolfChoices = [...roles].filter(role => CUSTOM_ROSTER_WOLF_CATALOG.includes(role)
    || role === 'wolf_elder' || role === 'wolf_younger')
  return {
    extraRole: extraRoles.length === 1 ? extraRoles[0] : undefined,
    wolfChoice: wolfChoices.length === 2 && wolfChoices.includes('wolf_elder') && wolfChoices.includes('wolf_younger')
      ? CUSTOM_ROSTER_WOLF_PAIR
      : wolfChoices.length === 1 && CUSTOM_ROSTER_WOLF_CHOICES.includes(wolfChoices[0]!) ? wolfChoices[0] : undefined,
  }
}

export function customRosterSelectionKeys(
  playerCount: CustomRosterPlayerCount,
  extraRole?: string,
  wolfChoice?: string,
): Set<string> {
  const ordinaryWolves = (playerCount === 10 ? 3 : 4)
    - (wolfChoice === CUSTOM_ROSTER_WOLF_PAIR ? 2 : wolfChoice ? 1 : 0)
  return new Set([
    ...CUSTOM_ROSTER_FIXED_ROLES,
    ...(extraRole ? [extraRole] : []),
    ...(wolfChoice ? [wolfChoice] : []),
    ...Array.from({ length: ordinaryWolves }, (_, index) => index === 0 ? 'werewolf' : `werewolf_${index + 1}`),
  ])
}

export function customRosterVillagerKeys(playerCount: CustomRosterPlayerCount): Set<number> {
  return new Set(Array.from({ length: playerCount === 10 ? 3 : 4 }, (_, index) => index))
}
